angular
  .module 'gym.components'
  .directive 'reportLocationFilter', ->
    restrict: 'E'
    template: require('templates/components/reports/report_location_filter.html.slim')
